/**
 * Validates a returnTo path from URL query params to prevent open redirects.
 * Only allows same-app relative paths (starting with a single `/`).
 * Rejects protocol-relative URLs (`//...`), absolute URLs, and non-path strings.
 */
export function sanitizeReturnTo(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return '/';
  }
  return value;
}